import { inPracticeZone } from '@tebuto/functions/practice-time'
import { DateTime } from 'luxon'

/** Calendar cells and the selected date are plain calendar dates; their zone carries no meaning. */
export function calendarCellDayKey(day: DateTime): string {
    return day.toISODate() ?? ''
}

/** An appointment belongs to the practice-local day it starts on, wherever the viewer is. */
export function eventDayKey(eventStart: DateTime): string {
    return inPracticeZone(eventStart).toISODate() ?? ''
}

export function eventWeekday(eventStart: DateTime): number {
    return inPracticeZone(eventStart).weekday
}

export function calendarCellForEvent(eventStart: DateTime): DateTime<true> {
    const cell = DateTime.fromISO(eventDayKey(eventStart))
    if (!cell.isValid) {
        throw new Error(`Cannot derive calendar day from event start ${eventStart.toISO()}`)
    }
    return cell
}
